import { Component, Input, OnInit } from '@angular/core';
import { ProductionSchedulingCounts } from 'src/app/core/interfaces/status-counts/production-scheduling-counts';

@Component({
  selector: 'app-production-scheduling-counts',
  templateUrl: './production-scheduling-counts.component.html',
  styleUrls: ['./production-scheduling-counts.component.scss'],
})
export class ProductionSchedulingCountsComponent implements OnInit {
  @Input() productionSchedulingCounts: ProductionSchedulingCounts;

  constructor() {}

  ngOnInit(): void {}
}
